import { memo } from 'react'
import { Spinner, Row, Col } from 'react-bootstrap';

const LoginLoader = ({ spinner, spinnerContent, ...props }) => {
    return (
        spinner &&
        <div className='spinner-overlay'>
            <Row className='g-0'>
                <Col>
                    <div className='text-center mb-3'>
                        <Spinner className='spinner-border color-text' animation="border" />
                    </div>
                    <div className='font-regular font-size12 color-text'>{spinnerContent}</div>
                </Col>
            </Row>
        </div>
    )
}
export default memo(LoginLoader);
